import { createSlice } from "@reduxjs/toolkit";
import { editAdminDetails, getAdminDetails, getAdmins, getAllClients, getAnalytics, getBots, getClientDetailById, getFaq, getFeedback, getNewClients, getNotifications, getPrompt, getReports, getReviews, getStatics } from "../Actions/auth";
import AdminActions from "../Actions/AdminActions";

const initialState = {
    loading: false,
    botList: {},
    adminList: {},
    feedbackList: {},
    analyticsData: {},
    staticsData: {},
    faqList: {},
    promptList: {},
    reviewList: {},
    newClientList: {},
    reportList: {},
    notificationtList: {},
    userDetail: [],
    allClientList: []
}

const UserSlice = createSlice({
    name: "user",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getBots.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.botList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getAdmins.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.adminList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getFeedback.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.feedbackList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getAnalytics.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.analyticsData = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getStatics.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.staticsData = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getFaq.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.faqList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getPrompt.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.promptList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getReviews.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.reviewList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getNewClients.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.newClientList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getReports.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.reportList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(getNotifications.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.notificationtList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })

        // ==========================================================================================

        builder.addCase(getAdminDetails.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.adminDetail = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        builder.addCase(AdminActions.verifyOtp.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.adminDetail = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })

        builder.addCase(editAdminDetails.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.adminDetail = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
        // ==========================================================================================

        builder.addCase(getClientDetailById.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.userDetail = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })

        // ==========================================================================================

        builder.addCase(getAllClients.fulfilled, (state, { payload }) => {
            if (payload?.status == 200) {
                state.success = true;
                state.allClientList = payload.data;
            } else {
                state.success = false;
                state.error = payload?.message
            }
        })
    },
});

export default UserSlice.reducer;